module.exports = __webpack_public_path__ + "img/pardos_h.b0b8b8e9.png";